import module from 'finanzas/module.js'
import template from './template.html'

export class CargaMovimientosBancariosHistorialEliminarConfirmarComponent {
  cerrar = false
  idLote
  titulo
  subtitulo
  capturaUsuario
  capturaFecha
  usuarioEliminar
  procesando = false
  resultado = {exito: false}
  onClose

  constructor (FinancesCargarMovimientosBancariosHistorial) {
    this.FinancesCargarMovimientosBancariosHistorialService = FinancesCargarMovimientosBancariosHistorial
  }

  eliminar () {
    if (this.procesando) return

    this.procesando = true

    this.FinancesCargarMovimientosBancariosHistorialService.delete(this.idLote)
      .then(() => (this.resultado.exito = true))
      .catch((error) => {
        this.error = error.data
        this.procesando = false
      })
  }

  cancelar () {
    this.onClose({$event: {detail: this.resultado}})
  }
}

module.component('financesCargamovimientosbancariosHistorialEliminarConfirmar', {
  controller: CargaMovimientosBancariosHistorialEliminarConfirmarComponent,
  template,
  bindings: {
    idLote: '<',
    titulo: '<',
    subtitulo: '<',
    capturaFecha: '<',
    capturaUsuario: '<',
    usuarioEliminar:'<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/finanzas/components/cargaMovimientosBancarios/historial/eliminar/confirmar/component.js